"use client"

import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import LocationInput from './LocationInput';
import { SearchPageSearchParams } from '@/types';
import { RecordModel } from 'pocketbase';

function DistanceInput({ params, searchParams, location, commodityType, petType, commodity, adType }: { params: any, searchParams: SearchPageSearchParams, location?: RecordModel, commodityType?: any, petType?: any, commodity?: any, adType?: any }) {
  const router = useRouter();
  const radiusParam = searchParams?.radius || 'Nationwide';
  const [controlledLocation, setControlledLocation] = useState<RecordModel | null>(location || null);
  const [distance, setDistance] = useState<number | string>(radiusParam);

  const distances = ['Nationwide', 1, 3, 5, 10, 15, 30, 50, 75, 100, 150];

  useEffect(() => {
    if (location) {
      setControlledLocation(location);
    }
  }, [location]);

  const handleLocationChange = (newLocation: RecordModel) => {
    setControlledLocation(newLocation);
    if (newLocation) {
      const formattedLocation = newLocation.locationName.toLowerCase().replace(/ /g, "-");
      const searchParamsString = new URLSearchParams(searchParams as any).toString();
      const newPath = `${window.location.pathname.replace(/\/[^\/]+-[0-9]{4}/, '')}/${formattedLocation}-${newLocation.postcode}?${searchParamsString}`;
      router.push(newPath);
    }
  };

  const handleDistanceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newDistance = e.target.value;
    setDistance(newDistance);
    if (location) {
      const newSearchParams = new URLSearchParams(searchParams as any);
      newSearchParams.set('radius', newDistance.toString());
      const newPath = `${window.location.pathname}?${newSearchParams.toString()}`;
      router.push(newPath);
    }
  };

  return (
    <div className='mb-2'>
      <LocationInput
        initialLocationId={controlledLocation?.id}
        onChange={handleLocationChange}
        placeholder='All of Australia'
      />
      <div>
        <select
          value={distance}
          onChange={handleDistanceChange}
          className={`input input-bordered w-full ${controlledLocation?.location == "" ? "input-disabled" :""}`}
          disabled={controlledLocation?.location == ""}
        >
          {distances.map((dist, index) => (
            <option key={index} value={dist}>
              {typeof dist === 'number' ? `${dist} km` : dist}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

export default DistanceInput;